import React, { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { ImageLink } from '../constants'
import axiosInstance from '../axiosInterceptor'

const AddBanner = () => {
    const navigator = useNavigate();
    const location = useLocation();
    const editData = location.state
    const [data, setData] = useState({
        position: editData?.position || '',
        desktopImg: editData?.desktopImg || '',
        mobileImg: editData?.mobileImg || '',
        link: editData?.link || '',
    });
    const [errors, setErrors] = useState({
        position: '',
        desktopImg: '',
        mobileImg: '',
        link: '',
    });

    const handleChange = (e) => {
        const { name, files, value } = e.target;
        if (name === 'desktopImg' || name === 'mobileImg') {
            setData({ ...data, [name]: files.length > 0 ? files[0] : null });
        } else {
            setData({ ...data, [name]: value });
        }
        setErrors({ ...errors, [name]: '' });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        let hasErrors = false;

        if (!data.position.trim()) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                position: 'Position is required'
            }));
            hasErrors = true;
        }

        if (!data.desktopImg) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                desktopImg: 'Desktop img is required'
            }));
            hasErrors = true;
        }
        if (!data.mobileImg) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                mobileImg: 'mobile img is required'
            }));
            hasErrors = true;
        }
        if (!data.link) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                link: 'link is required'
            }));
            hasErrors = true;
        }

        // If there are errors, stop further processing
        if (hasErrors) {
            return;
        }

        try {
            const formData = new FormData();
            formData.append("position", data.position);
            if (data.desktopImg instanceof File) {
                formData.append("desktopImg", data.desktopImg);
            }
            if (data.mobileImg instanceof File) {
                formData.append("mobileImg", data.mobileImg);
            }
            formData.append("link", data.link);
            const response = await axiosInstance.post(`banner/createBanner`, formData);
            if (response.status === 200) {
                toast.success(response.data.message);
                navigator("/banner");
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };
    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            formData.append("position", data.position);
            if (data.desktopImg instanceof File) {
                formData.append("desktopImg", data.desktopImg);
            }
            if (data.mobileImg instanceof File) {
                formData.append("mobileImg", data.mobileImg);
            }
            formData.append("link", data.link);
            const response = await axiosInstance.put(`banner/updateBanner/${editData?._id}`, formData);
            if (response.status === 200) {
                toast.success(response.data.message);
                navigator("/banner");
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        }
    };

    return (
        <>
            <div className="content-wrapper">
                <div className="page-header mx-4 mt-5">
                    <h3 className="page-title">Add Banner</h3>
                </div>
                <div className="col-md-12 grid-margin stretch-card">
                    <div className="col-md-8  ">
                        <div className="card">
                            <div className="card-body">
                                <form className="pt-3" onSubmit={editData?._id ? handleUpdate : handleSubmit}>
                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Position
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="number"
                                                className="form-control form-control-sm"
                                                id="position"
                                                name="position"
                                                placeholder="Enter position"
                                                value={data.position}
                                                onChange={handleChange}
                                            />
                                            {errors.position && <p className="text-danger">{errors.position}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Desktop Img
                                        </label>

                                        <div className="col-sm-9">
                                            <input
                                                type="file"
                                                className="form-control form-control-sm"
                                                id="desktopImg"
                                                name="desktopImg"
                                                placeholder="Enter desktop img"
                                                // value={data.desktopImg}
                                                onChange={handleChange}
                                            />
                                            {errors.desktopImg && <p className="text-danger">{errors.desktopImg}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Mobile Img
                                        </label>

                                        <div className="col-sm-9">
                                            <input
                                                type="file"
                                                className="form-control form-control-sm"
                                                id="mobileImg"
                                                name="mobileImg"
                                                placeholder="Enter desktop img"
                                                // value={data.desktopImg}
                                                onChange={handleChange}
                                            />
                                            {errors.mobileImg && <p className="text-danger">{errors.mobileImg}</p>}
                                        </div>
                                    </div>
                                    <div className="form-group row">
                                        <label
                                            htmlFor="exampleInputUsername2"
                                            className="col-sm-3 col-form-label"
                                        >
                                            Url
                                        </label>
                                        <div className="col-sm-9">
                                            <input
                                                type="text"
                                                className="form-control form-control-sm"
                                                id="link"
                                                name="link"
                                                placeholder="Enter link"
                                                value={data.link}
                                                onChange={handleChange}
                                            />
                                            {errors.link && <p className="text-danger">{errors.link}</p>}
                                        </div>
                                    </div>
                                    <div className='text-center'>
                                        <Link to="/banner"><button className="btn btn-secondary mr-2">
                                            Back </button></Link>
                                        <button type="submit" className="btn btn-success">
                                            Submit
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 stretch-card">
                        <div className="card">
                            {data.desktopImg &&
                                <div className="w-100 h-80 text-center mb-4">
                                    <p className="mt-3">Desktop Image Preview</p>
                                    <br />
                                    {data.desktopImg instanceof File ? (
                                        <img src={URL.createObjectURL(data.desktopImg)} alt="Preview" className="w-50 preview-img" />
                                    ) : (
                                        <img src={ImageLink(data.desktopImg)} alt="Preview" className="w-50 preview-img" />
                                    )}
                                </div>
                            }
                            <hr />
                            {data.mobileImg &&
                                <div className="w-100 h-80 text-center mb-4">
                                    <h6 className="mt-3">Mobile Image Preview</h6>
                                    <br />
                                    {data.mobileImg instanceof File ? (
                                        <img src={URL.createObjectURL(data.mobileImg)} alt="Preview" className="w-50 preview-img" />
                                    ) : (
                                        <img src={ImageLink(data.mobileImg)} alt="Preview" className="w-50 preview-img" />
                                    )}
                                </div>

                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddBanner;